<template>
    <div class="mt-3 flex items-start">
        <div class="mt-1">
            <div 
                v-if="listIconType === 'bullet'"
                class="w-[8px] h-[8px] rounded-full"
                :class="`bg-[${color}]`"
            />

            <img
                v-else
                src="/images/campaigns/quote-checked-icon.svg"
                alt="Quote checked icon"
            />
        </div>

        <p class="ml-2 list-item-parent lg:leading-snug text-[#1B2F51]">
            <span v-html="textContent" />

            <v-tooltip v-if="tooltipContent" location="right">
                <template v-slot:activator="{ props }">
                    <img
                        v-bind="props"
                        src="/images/campaigns/tooltip-icon.svg"
                        class="cursor-pointer inline ml-2 -mt-[1.5px]"
                        alt="Tooltip icon"
                    />
                </template>

                <span>{{ tooltipContent }}</span>
            </v-tooltip>
        </p>
    </div>
</template>

<script>
export default {
    props: {
        textContent: {
            type: String,
            required: true,
        },
        tooltipContent: {
            type: String,
            required: false,
            default: null,
        },
        listIconType: {
            type: String,
            required: false,
            default: 'checked',
        },
        color: {
            type: String,
            required: false,
            default: '#1EB26D',
        },
    },
};
</script>

<style scoped>
.list-item-parent {
    font-size: 12px;
}

@media screen and (min-width: 1024px) {
    .list-item-parent {
        font-size: 14px;
    }
}
</style>
